var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.75C12.6952 3.75002 12.8725 3.86369 12.9541 4.04102C13.0357 4.21832 13.0068 4.42692 12.8799 4.5752L9.40039 8.63965V12.5C9.40039 12.6728 9.31082 12.8336 9.16406 12.9248C9.01728 13.016 8.83367 13.0247 8.67871 12.9482L6.87891 12.0596C6.70837 11.9754 6.5997 11.8015 6.59961 11.6113V8.63965L3.12012 4.5752C2.99316 4.42691 2.96428 4.21834 3.0459 4.04102C3.12752 3.86368 3.30478 3.75 3.5 3.75H12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fdc6c6a70a9f688483c86ed93859ae07.svg";
export { ForwardRef as ReactComponent };